import React from 'react'
import MyButton from '../../UI/form/MyButton'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../helpers/form/FormHelper'
import CommentTextField from './fields/CommentTextField'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { addCommentAPI } from '../../../api/comment/commentAPI'
import { useDispatch } from 'react-redux'
import { addComment } from '../../../store/commentSlice'

const CommentSendBlock = ({ supplyOrderId, supplyBillId, supplierId, writeOffActId }) => {

    const dispatch = useDispatch()

	const [data, setData] = useState({})

    // console.log('data', data)

	const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

	 const send = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        addCommentAPI(dataForBd).then(data => {
            // setOpen(false)
            dispatch(addComment(data))
            setLoading(false)
            setData({})
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

	const getDataForBd = () => {
        const dataForBd = {
            supplyOrderId: supplyOrderId,
            supplyBillId: supplyBillId,
            supplierId: supplierId,
            writeOffActId: writeOffActId,
            text: data.text
            // id: supplyBillItemBd.id,
            // priceOne: data.priceOne,
            // priceGeneral: data.priceGeneral,
            // currency: data.currency,
        }

        return dataForBd
    }


  return (
    <div className='commentsBlock__sendBlock'>

		<ErrorMessage
            error={error}
        />

        <div className='commentsBlock__sendBlock-comment'>
            {
				formDataProductIsField('text', 'comment') ?
					<CommentTextField
						required={formDataProductRequiredField('text', 'comment')}
						setValidate={e => updateValidate(setValid, 'text', e)}
						setValueForm={e => setValueForm(setData, 'text', e)}
						forciblyValue={data && data.text ? data.text : ''}
					/>
				: ''
			}
        </div>
        <div className='commentsBlock__sendBlock-button'>
            <MyButton
				onClick={send}
				disabled={!isValidForm || loading ? true : false}
			>
                Надіслати
            </MyButton>
        </div>
    </div>
  )
}

export default CommentSendBlock